/**
 * PP Jewellers — Premium Header JS
 * Announcement rotator · Sticky scroll · Mega menu · Mobile drawer
 */
(function () {
  'use strict';

  /* ──────────────────────────────────────────
     ANNOUNCEMENT ROTATOR
  ────────────────────────────────────────── */
  var annBar = document.getElementById('PPAnnouncement');
  if (annBar) {
    var msgs    = Array.prototype.slice.call(annBar.querySelectorAll('.pp-announcement__msg'));
    var prevBtn = annBar.querySelector('[data-ann-prev]');
    var nextBtn = annBar.querySelector('[data-ann-next]');
    var current = 0;
    var rotateTimer;

    var TRANSITION_MS = 600;
    var INTERVAL_MS   = 5000;
    var transitioning = false;

    function showMsg(idx) {
      msgs.forEach(function (m, i) {
        m.classList.toggle('is-active', i === idx);
        m.classList.remove('is-leaving');
      });
    }

    function go(dir) {
      if (transitioning) return;
      transitioning = true;

      var outgoing = msgs[current];
      current = (current + dir + msgs.length) % msgs.length;
      var incoming = msgs[current];

      // Exit outgoing upward, enter incoming from below
      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      incoming.classList.add('is-active');

      setTimeout(function () {
        outgoing.classList.remove('is-leaving');
        transitioning = false;
      }, TRANSITION_MS + 50);

      restartRotate();
    }

    function restartRotate() {
      clearInterval(rotateTimer);
      if (msgs.length > 1) {
        rotateTimer = setInterval(function () { go(1); }, INTERVAL_MS);
      }
    }

    if (msgs.length > 0) {
      showMsg(0);
      restartRotate();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
  }


  /* ──────────────────────────────────────────
     MEGA MENU — hover with 80/180ms debounce
  ────────────────────────────────────────── */
  var megaItems = Array.prototype.slice.call(
    document.querySelectorAll('.pp-nav__item[data-mega]')
  );

  megaItems.forEach(function (item) {
    var openTimer, closeTimer;

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () {
        megaItems.forEach(function (other) {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.add('is-open');
      }, 80);
    });

    item.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
      }, 180);
    });
  });

  // ESC closes all megas
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      megaItems.forEach(function (item) { item.classList.remove('is-open'); });
    }
  });

  /* ──────────────────────────────────────────
     MOBILE DRAWER
  ────────────────────────────────────────── */
  var drawer  = document.getElementById('PPMobileDrawer');
  var overlay = document.getElementById('PPDrawerOverlay');
  var openBtn = document.getElementById('PPDrawerOpen');
  var closeBtn = document.getElementById('PPDrawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (openBtn) openBtn.focus();
  }

  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* Mobile drawer accordion */
  if (drawer) {
    drawer.querySelectorAll('.pp-drawer__item-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item   = toggle.closest('.pp-drawer__item');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        drawer.querySelectorAll('.pp-drawer__item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

})();
